import type { JSX } from "react";

import { Button } from "@/components/ui/button";

import type { UesFieldDef } from "../../domain/entities/doc-type";
import {
  addField,
  removeAt,
  updateAt,
  type FieldPath,
} from "../schema-editor-ops";
import type { FieldError } from "../schema-validation";
import { FieldRow } from "./field-row";

export interface SchemaEditorProps {
  value: UesFieldDef[];
  onChange: (next: UesFieldDef[]) => void;
  errors: FieldError[];
}

export function SchemaEditor({
  value,
  onChange,
  errors,
}: SchemaEditorProps): JSX.Element {
  const handlePatch = (
    path: FieldPath,
    patch: Partial<UesFieldDef>,
  ): void => {
    onChange(updateAt(value, path, patch));
  };

  const handleRemove = (path: FieldPath): void => {
    onChange(removeAt(value, path));
  };

  const handleAddChild = (path: FieldPath): void => {
    onChange(addField(value, path));
  };

  return (
    <div className="space-y-3">
      {value.map((field, index) => (
        <FieldRow
          key={index}
          field={field}
          path={[index]}
          errors={errors}
          onPatch={handlePatch}
          onRemove={handleRemove}
          onAddChild={handleAddChild}
        />
      ))}
      <Button
        type="button"
        variant="outline"
        onClick={() => onChange(addField(value, []))}
      >
        Add field
      </Button>
    </div>
  );
}
